import React, { Fragment } from 'react'
import { Button, Input } from '@nextui-org/react'
import { inputs } from './constants'
import { handlePriceChange, handleKeyPress } from './controller'
import { formStyles } from './styles'
import PropTypes from 'prop-types'

const Form = ({ watch, register, setValue, errors, loading, handleSimulate, isDisabled }) => {
  return (
    <form className={formStyles.MAIN_CONTAINER}>
      {inputs.map((input, index) => {
        return (
          <Fragment key={index}>
            <p className={formStyles.LABEL}>{input.label}</p>
            <Input
              // label={input.label}
              type={input.type}
              name={input.name}
              className={input.className}
              color={errors[input.name] ? 'danger' : 'primary'}
              placeholder={input.placeholder}
              {...register(input.name)}
              errorMessage={errors[input.name]?.message}
              isRequired={input.isRequired}
              variant="bordered"
              aria-label="input"
              aria-labelledby="input"
              defaultValue={watch()[input.name]}
              onChange={(e) => handlePriceChange(input.name, e, setValue)}
              onKeyDown={(e) => handleKeyPress(input.name, e, setValue)}
              classNames={{
                label: 'hidden',
                inputWrapper: 'rounded-3xl ',
              }}
            />
          </Fragment>
        )
      })}
      <div className="flex justify-center w-full col-span-2 mt-6">
        <Button
          type="submit"
          color="primary"
          size="lg"
          className="font-bold rounded-3xl"
          variant="shadow"
          isLoading={loading}
          isDisabled={isDisabled}
          onClick={() => handleSimulate()}
        >
          Ver resultados
        </Button>
      </div>
    </form>
  )
}

Form.propTypes = {
  watch: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  handleSimulate: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default Form
